import React from 'react';
import { ElasticTextBoxField, StyledStackPanel, urlRegExp } from 'common';
import { Typography } from '@agilepoint/wat-react-ux';
import { Localize, useTranslate } from '@agilepoint/wat-react';
import { PushNotificationsWrapper } from '../styled-components';

export const PushNotificationForm = React.memo(() => {
    const translate = useTranslate();

    return (
        <StyledStackPanel margin='30px 0px 0px 0px' gap="30" height={'calc(100% - 111px)'} width="100%" orientation='vertical' alignment="center">
            <Typography.H2 title={translate('modules.createNewApp.steps.pushNotification.headerLabel')}><Localize translate='modules.createNewApp.steps.pushNotification.headerLabel' /></Typography.H2>
            <PushNotificationsWrapper width='660px' orientation='vertical' gap="20" height="calc(100% - 60px)">
                <ElasticTextBoxField
                    name="hostUrl"
                    title={translate('modules.createNewApp.steps.pushNotification.formFields.hostURL')}
                    label={translate('modules.createNewApp.steps.pushNotification.formFields.hostURL')}
                    validationRules={{
                        pattern: { value: urlRegExp, message: translate('common.messages.validSiteUriText') }
                    }}
                />
                <ElasticTextBoxField
                    name="domain"
                    title={translate('modules.createNewApp.steps.pushNotification.formFields.domain')}
                    label={translate('modules.createNewApp.steps.pushNotification.formFields.domain')}
                />
                <ElasticTextBoxField
                    name="value1"
                    title={translate('modules.createNewApp.steps.pushNotification.formFields.value1')}
                    label={translate('modules.createNewApp.steps.pushNotification.formFields.value1')}
                />
                <ElasticTextBoxField
                    name="value2"
                    title={translate('modules.createNewApp.steps.pushNotification.formFields.value2')}
                    label={translate('modules.createNewApp.steps.pushNotification.formFields.value2')}
                />
            </PushNotificationsWrapper>
        </StyledStackPanel>
    );
});
